import React from 'react'

const config = {
  types: [
    {
      title: 'default',
      isDefault: true
    }
  ],
  modifiers: [],
  states: [],
  starsLength: 5
}

const useRating = () => {
  const renderRatingStars = (currentRate) => {
    return currentRate && rateReadOnly(currentRate)
  }

  const rateReadOnly = (index, readOnly) => {
    if (!readOnly) {
      return
    }
    const decimalBR = String(index).replace('.', ',')
    return (
      <h3 className="mdn-RatingStars-rate mdn-Heading mdn-Heading--sm">
        {decimalBR}
      </h3>
    )
  }

  const getType = (currentRate, index) => {
    const value = currentRate - index
    if (value >= 0.7) return 'avaliacao'
    if (value < 0.7 && value >= 0.3) return 'avaliacao-meia'

    return 'avaliacao-vazia'
  }

  const renderTotalRating = (readOnly, children) => {
    if (!readOnly) {
      return
    }
    return (
      <p className="mdn-RatingStars-evaluation mdn-Text mdn-Text--caption ">
        {children}
      </p>
    )
  }

  return {
    config,
    getType,
    renderRatingStars,
    rateReadOnly,
    renderTotalRating

  }
}

export default useRating
